import type { FaireProductEntity } from "../../entity_types/product";

export const p_met3mcrq6v: FaireProductEntity = {
  token: "p_met3mcrq6v",
  type: "product",
  name: "Kitchen Timer, Pancake Smile",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/0f1c428174fb11ecac4fe25d05ae5ff5f6262a9d66ec26054364e3206c12c2e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6788eac490d7e233e54e3688cc7b60f9ccd18250a83ed36c6cc0b11e76755b81.jpeg",
    "https://cdn.faire.com/fastly/a9d4fa781053f657c0712138075493944077872fbb0c9bf0513d3d3049079231.jpeg",
    "https://cdn.faire.com/fastly/4c89b03f9f3710dee5427bdc97412f52acd248d3df791016fe2db04081e8dfaa.jpeg",
    "https://cdn.faire.com/fastly/f1bbcf5d86c29144587af47bf92b3b354299501089d08f6480b03cf413e261c1.jpeg",
    "https://cdn.faire.com/fastly/c342ed7c70960f6133790d94c051e92b4e08ce9124b300c3030504ea56f3e6c5.jpeg",
    "https://cdn.faire.com/fastly/659638fddffc6346490e4c1217ead575dd7a14636a239ddea0a18be6b762def1.jpeg"
  ],
  priceDollars: 12,
  description: "What time is it? It’s pancake time! (Or pizza time or soup time or cake time.) This adorable 60-minute kitchen timer keeps you on track while looking impossibly cute on your counter. Equal parts functional and fun, it’s the little culinary companion you didn’t know you needed.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• 60-minute mechanical timer\n• Playful food-inspired design that brightens any kitchen\n• No batteries required — just twist and go\n• Perfect for cooking, baking, studying, or timing your self-care moments\n• Designed in ban.do’s signature cheerful and whimsical style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and kitchenware boutiques\n• Home décor and lifestyle retailers\n• Home cooks, bakers, and fans of cute kitchen gadgets\n• Wholesale buyers seeking fun, functional countertop accessories",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:18.687Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
